import { render } from "./Investors.vue?vue&type=template&id=60a2c9bf&scoped=true"
import script from "./Investors.vue?vue&type=script&lang=js"
export * from "./Investors.vue?vue&type=script&lang=js"

import "./Investors.vue?vue&type=style&index=0&id=60a2c9bf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a2c9bf"]])

export default __exports__